var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"timer"},[_c('i',[_vm._v(_vm._s(_vm.emoji.time.image))]),_c('span',[_vm._v(_vm._s(_vm.emoji.time.desc))]),_c('span',[_vm._v(_vm._s(_vm.countTime))])])}
var staticRenderFns = []

export { render, staticRenderFns }